export interface EmailAuthent {
  email: string;
  idNat: string;
}

export const MSS_EMAIL_REGEX = /^[a-z0-9!#$%&'*+=?^_.`{|}~-]+(?:\\.[a-z0-9!#$%&'*+=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;
